const projectNotification = {
    PRODUCT_ADDED: 'project-product-added',
    PRODUCT_REMOVED: 'project-product-removed',
    DOWNLOAD_PROPOSAL: 'download-proposal',
    GENERAL: 'general',
};

export { projectNotification };
